import { render, staticRenderFns } from "./wzzj1.vue?vue&type=template&id=653f7066&scoped=true&"
import script from "./wzzj1.vue?vue&type=script&lang=js&"
export * from "./wzzj1.vue?vue&type=script&lang=js&"
import style0 from "./wzzj1.vue?vue&type=style&index=0&id=653f7066&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653f7066",
  null
  
)

export default component.exports